import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button, Paper, Popover, Tooltip } from '@mui/material';

import { hasTrussDesignPermission as hasTrussDesignPermissionSelector } from '@paragon/login-tools';

import { inViewOnlyMode } from '../../../store/selectors/viewOnlyModeSelectors';
import { useAppSelector } from '../../hooks';
import { AddItemMenu } from '../../misc/menus/add-items/AddItemMenu';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

interface Props {
  condensed?: boolean;
}

export default function AddItemButton({ condensed }: Props) {
  const hasTrussDesignPermission = useAppSelector(hasTrussDesignPermissionSelector);
  const isViewOnlyComponent = useAppSelector(inViewOnlyMode);
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  function onPopoverClose() {
    setPopoverOpen(false);
  }

  const handleChange = (event: React.MouseEvent<HTMLElement>) => {
    setPopoverOpen(true);
    setAnchorEl(event.currentTarget);
  };

  if (!hasTrussDesignPermission) return null;

  const tooltipTitle = 'Create (Ctrl + Q)';
  const disabled = isViewOnlyComponent;
  const icon = <AddIcon />;

  return (
    <>
      {isPopoverOpen && (
        <Popover
          open={isPopoverOpen}
          anchorEl={anchorEl}
          onClose={() => {
            onPopoverClose();
            setAnchorEl(null);
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Paper elevation={1}>
            <AddItemMenu monitorText="Top menu click" onChooseItem={onPopoverClose} />
          </Paper>
        </Popover>
      )}

      {condensed ? (
        <ToolbarIconButton title={tooltipTitle} icon={icon} onClick={handleChange} disabled={disabled} />
      ) : (
        <Tooltip disableInteractive title={tooltipTitle}>
          <span>
            <Button
              size="small"
              variant="contained"
              color="primary"
              aria-label="create"
              onClick={handleChange}
              disabled={disabled}
              startIcon={icon}
            >
              Create
            </Button>
          </span>
        </Tooltip>
      )}
    </>
  );
}
